var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "sidebar" }, [
      _vm._m(0),
      _vm.error
        ? _c(
            "div",
            [
              _c("Alert", { attrs: { message: _vm.error } }),
              _c(
                "div",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      return _vm.navigateTo("forgot-password")
                    }
                  }
                },
                [_vm._v("Back to Forgot Password →")]
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.error
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.resetPassword($event)
                }
              }
            },
            [
              _c("Alert", { attrs: { message: _vm.message } }),
              !_vm.success
                ? _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("New Password")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      attrs: { required: "", type: "password" },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              !_vm.success
                ? _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Password Confirmation")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password2,
                          expression: "password2"
                        }
                      ],
                      attrs: { required: "", type: "password" },
                      domProps: { value: _vm.password2 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password2 = $event.target.value
                        }
                      }
                    })
                  ])
                : _vm._e(),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "primary",
                      class: [
                        _vm.loading === 1
                          ? "load"
                          : _vm.loading === 2
                          ? "ok"
                          : null
                      ],
                      attrs: { type: "submit" }
                    },
                    [_vm._v(" Update Password ")]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      return _vm.navigateTo("/login")
                    }
                  }
                },
                [_vm._v("Back to Login →")]
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "footer" })
    ]),
    _c("div", {
      staticClass: "image bg-local",
      style: { "background-image": "url('" + _vm.image + "')" }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("img", {
        staticClass: "h-20 mr-4",
        attrs: { src: require("@/assets/img/logo.svg") }
      }),
      _c("div", { staticClass: "brand" }, [
        _c("div", { staticClass: "title" }, [_vm._v("PandaVue")]),
        _c("div", { staticClass: "subtitle" }, [_vm._v("WWF-Australia")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }